import { render, staticRenderFns } from "./shareGiftBag.vue?vue&type=template&id=9d95be56&scoped=true&"
import script from "./shareGiftBag.vue?vue&type=script&lang=js&"
export * from "./shareGiftBag.vue?vue&type=script&lang=js&"
import style0 from "./shareGiftBag.vue?vue&type=style&index=0&id=9d95be56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d95be56",
  null
  
)

export default component.exports